<fgb-page-header [pageTitle]="'account.nav.profile'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-banner [bannerTitle]="'account.activity.page.title' | translate"></fgb-banner>

<fgb-account-nav></fgb-account-nav>

<div class="container">
  <div class="points-history">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
  </div>
</div>
